<template>
  <div class="news-plan">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.4)'" />
    </div>
    <div class="content">
      <div class="banner">
        <img src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662103069023877846.png" alt="">
      </div>
      <div class="article">
        <template v-for="(item,index) in list">

          <div class="item">
            <div class="top">
              <div class="cover">
                <el-image :src="item.cover"></el-image>
              </div>
              <div class="detail">
                <div class="title">{{item.title}}</div>
                <div>

                <div class="arrow" @click="item.showInfo = !item.showInfo">
                  <el-image :src="require('@/assets/slices/icon_right.png')" v-if="!item.showInfo" ></el-image>
                  <el-image :src="require('@/assets/slices/icon_down.png')" v-else></el-image>
                </div>
                <div class="desc">{{item.desc}}</div>
                </div>
              </div>
            </div>
            <el-collapse-transition>
            <div class="info" v-html="item.info" v-show="item.showInfo"></div>
            </el-collapse-transition>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'

export default {
  components: {
    layoutHeader,
  },
  name: 'layout',
  data() {
    return {
      list: [
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232299053290825.jpg',
          title: '3D智慧党建',
          desc: '构筑红色文化新阵地',
          info: '三维易境利用裸眼3D显示技术满足了数字化时代党建发展的新需求，线上虚拟展厅加线下裸眼3D显示，不仅可以用3D的方式还原展品、场景，打造高互动性和沉浸式的体验感，同时利用2D转3D技术，可以实现革命历史文物的保护，3D数字化和科技化为历史的传播提供了新的方式。',
          showInfo: false
        },
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232330358650604.jpg',
          title: '3D智慧城市',
          desc: '赋能产业转型升级',
          info: '利用数字孪生技术，采用电影级 3D 实时渲染引擎，将物理城市与数字空间塑造成相对应的“孪生城市”，在3D场景中呈现城市静态数据、及物联感知数据，展现城市全貌，并实时对接后台，使数据同步更新，实现物理城市与孪生城市的数实交互。',
          showInfo: false
        },
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232352935289215.jpg',
          title: '3D数字化展览展示',
          desc: '驱动场景营销  创造非凡体验',
          info: '作为数字化展览展示的深耕者，三维易境致力以5G、AI、3D等数字科技展示手法，多层次地运用互动多媒体数字展示手段，实现展厅展馆的数字化、信息化、智能化、动态化，丰富展览方式和感官体验，重塑展览展示服务模式，为行业发展赋能。',
          showInfo: false
        },
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232374366376953.jpg',
          title: '智慧文旅',
          desc: '推动文化领域信息化进程',
          info: '智慧景区核心是依托三维易境数字孪生平台，将景区完美打造一个三维的虚实统一、实时互动的数字孪生体。将景区内建筑、基础设施、道路、机动目标等信息进行全方位展现，直观、完整地呈现景区三维态势。实现景区信息资源的共享与管理、各应用系统的交互操作和快速响应与联动控制，全面管理景区的运行状况，提高景区的管理水平和工作效率，提供决策的信息支持。',
          showInfo: false
        },
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232432237208800.jpg',
          title: '裸眼3D广告',
          desc: '耳目一新的广告内容传达模式  高效获客',
          info: '在数字生活时代，现有的信息流广告体系也会随着媒介的更新发展出全新的分发渠道。三维易境团队在裸眼3D领域深耕多年，针对全新的硬件设备，流行元素，社会风向等制定全新的广告内容，实现2D广告到3D广告的内容升级。\n' +
              '精彩“出格”的立体画面很大程度上激发人们的兴趣并增强记忆点，广告传播更具话题性及讨论性，实现广告商业价值。',
          showInfo: false
        },
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232455074323468.jpg',
          title: '3D教育解决方案',
          desc: '促进学校校园信息化建设、教育改革创新和学校品牌建设',
          info: '突破陈旧的教学方式，例如生物科学、航天科技以及工业设计等需要对物体内部构造进行详细剖析的课程，三维易境教育解决方案，综合应用AI和AR技术，通过3D建模虚拟再现真实的实验场景，借助先进的体感交互设备Kinect进行虚实互动，将真实的老师与虚拟仿真的实验器材结合到一个画面里，无需佩戴任何体感设备，纯手势就可以进行实验互动教学。',
          showInfo: false
        },
        {
          cover: 'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1665232391269291103.jpg',
          title: '裸眼3D医疗显示系统',
          desc: '跨界医疗成像  助力微创外科复杂性、高难度手术',
          info: '裸眼3D医疗显示系统图像色彩饱和，解决了佩戴偏光眼镜亮度和色彩度明显降低的问题，结合3D神经网络算法，实时追踪外科医生眼球，真实还原视野的3D纵深感，使腔镜手术达到一种更高精准度、更强实时互动的全新操作体验。',
          showInfo: false
        },
      ]
    }
  },
  created() {
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.news-plan {
  background: #111111;

  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .banner {
    width: 100%;
    img{
      width: 100%;
      height: auto;
    }
  }

  .article {
    width: 1420px;
    color: #fff;
    padding-top: 54px;

    .item {
      padding: 40px;
      background: rgba(66, 65, 65, 0.5);
      box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      margin-bottom: 28px;

      .top {
        display: flex;
        align-items: stretch;
      }

      .info {
        text-align: left;
        margin-top: 65px;
      }
    }

    .cover {
      .el-image {
        width: 326px;
        height: 181px;
        border-radius: 4px;
      }
    }

    .detail {
      flex: 1;
      text-align: left;
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-bottom: 1px solid #ffff;

      .title {
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
      }

      .arrow {
        text-align: right;
        cursor: pointer;

        img {
          width: 38px;
          height: 38px;
        }
      }

      .desc {
        width: 730px;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 38px;
      }

    }

    .info{
      line-height: 40px;
    }
  }
}
</style>
